module.exports = __webpack_public_path__ + "static/fulenwider.96e2908b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fulenwider.jpg
// module id = 454
// module chunks = 23899280101116